import { memo } from "react";

import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import uniqueId from "lodash/uniqueId";
import { ResolvedMegaMenuSectionLink } from "resolvers/base/megaMenuSectionLinksResolver";
import type { ResolvedMegaMenuSection } from "resolvers/base/megaMenuSectionResolver";

import styles from "../HeaderMegaMenu.module.scss";

const cx = classNames.bind(styles);

export type HeaderMegaMenuLinksProps = {
    sectionContent: ResolvedMegaMenuSection;
    children?: React.ReactNode;
    prefetch?: boolean;
};

const HeaderMegaMenuLinks: React.FC<HeaderMegaMenuLinksProps> = ({
    sectionContent,
    children,
    prefetch = false,
}: HeaderMegaMenuLinksProps) => {
    const { body } = sectionContent;
    return (
        <ul className={cx("linkSection")}>
            {(body as unknown as ResolvedMegaMenuSectionLink[])?.map(
                ({ link, text, target, subtitle }) => {
                    return !subtitle ? (
                        <li key={uniqueId()} className={cx("linkSectionItem")}>
                            <SmartLink href={link} prefetch={!!prefetch}>
                                <a target={target} className={cx("linkSectionLink")}>
                                    {text}
                                </a>
                            </SmartLink>
                        </li>
                    ) : (
                        <span
                            key={uniqueId()}
                            className={cx("sectionHeading", {
                                sectionSubtitle: subtitle,
                            })}
                        >
                            {link ? (
                                <SmartLink href={link} prefetch={!!prefetch}>
                                    <a target={target} className={cx("sectionHeadingLink")}>
                                        {text}
                                    </a>
                                </SmartLink>
                            ) : (
                                <span className={cx("sectionHeadingLink")}>{text}</span>
                            )}
                        </span>
                    );
                }
            )}
            {children}
        </ul>
    );
};

export default memo(HeaderMegaMenuLinks);
